import type { Stage } from '../kit';

/**
 * A themed celebration of one game: three tiers over the shared engine.
 *   win  — ≥1× the stake: a short local burst at the winning place (~0.8 s)
 *   big  — ≥10×: a full-screen salute in the game's material (~2 s)
 *   mega — ≥50×: the game's signature moment (~3–4 s), with the big amount (drawn by the caller or by celebrate())
 * Colours are #RRGGBB (the glow sprites append an alpha byte).
 */
export interface Preset {
  pal: readonly string[];
  /** glints, highlights */
  light: string;
  win(s: Stage): void;
  big(s: Stage): void;
  mega(s: Stage): void;
}

/** #RRGGBB → lighter / darker shades of it (the winner colour of Pot, a sector of Roulette). */
export function shades(hex: string): string[] {
  const m = /^#([0-9a-f]{6})$/i.exec(hex);
  if (!m?.[1]) return [hex];
  const n = parseInt(m[1], 16);
  const ch = [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  const mix = (t: number, to: number) =>
    '#' +
    ch
      .map((c) =>
        Math.round(c + (to - c) * t)
          .toString(16)
          .padStart(2, '0'),
      )
      .join('')
      .toUpperCase();
  return [hex.toUpperCase(), mix(0.35, 255), mix(0.6, 255), mix(0.3, 0)];
}

export const TAU = Math.PI * 2;
export const UP = -Math.PI / 2;
